// components/NeighborhoodFactorsSection.js
// Server component - uses shims for SSR compatibility

import { Grid } from "../../_shims/semantic-ui-react";
import IconsGrid from "../../_shims/IconsGrid";

// import { IconsGrid } from "../../../common/index.js";


export default function NeighborhoodFactorsSection({
  factors,
  factors_right,
  isMobile,
  amenitiesFlag,
  medianPriceDomCityFlag,
  appreciationCityFlag,
  handlescoreclick,
}) {
  return (
    <Grid>
      <Grid.Row className="img_deatils">
        <Grid.Column mobile={16} tablet={1} computer={1}></Grid.Column>

        {/* Neighborhood Factors */}
        <Grid.Column mobile={16} tablet={7} computer={7}>
          <p className="factor_titile">Neighborhood Factors</p>
          <IconsGrid
            gridData={factors}
            onscoreclick={handlescoreclick}
            isMobile={isMobile}
          />
          {amenitiesFlag && <p className="nh_level_txt">(1) Incomplete data</p>}
        </Grid.Column>

        {/* Market Conditions */}
        <Grid.Column mobile={16} tablet={7} computer={7}>
          <p className="factor_titile_market_cond">Market Conditions</p>
          <IconsGrid gridData={factors_right} />
          {(appreciationCityFlag || medianPriceDomCityFlag) && (
            <p className="city_level_txt">
              <>
                {medianPriceDomCityFlag && (
                  <span style={{ marginLeft: "10px" }}>(1) Limited data</span>
                )}
                {appreciationCityFlag && (
                  <span className={medianPriceDomCityFlag ? "ml-23" : "ml-50"}>
                    (2) City data used
                  </span>
                )}
              </>
            </p>
          )}
        </Grid.Column>

        <Grid.Column mobile={16} tablet={1} computer={1}></Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
